import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { NavItem, AdminNavEntryPoint } from '@retailer-platform/dashboard/routing'
import { yodaRulesAdminRouter } from './routing/yodaRulesAdminRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import ES_ES from './translations/es-ES.json'
import FR_FR from './translations/fr-FR.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'yoda-rules',
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'yoda-rules-dashboard-tool',
  },
  routes,
  translations: { EN_US, ES_ES, FR_FR },
  routers: {
    admin: [yodaRulesAdminRouter],
  },
  navigationEntries: [],
  adminNavigationEntries: [],
  // NOTE TO DEV: run `yarn ipp domain register <your-system-name>` to register your domain with Totem here
}

export default definition
